module.exports = __webpack_public_path__ + "static/media/small-circle.5ebf0f2a.png";